import styled from 'styled-components/macro';
import { Col } from '@yme/atoms/grid';
import { ADAPTIVE } from '@yme/tokens/screen';
export const ColStyled = styled(Col) `
  margin-bottom: 32px;

  ${ADAPTIVE.minWidth.tablet} {
    margin-bottom: 48px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    margin-bottom: 56px;
  }
`;
